import { Link } from '@framework/router/Next/Link';
import Button, { ButtonVariantType } from '@dealroadshow/uikit-button';
import CallToAction from '@framework/ui/Pages/Landing/Sections/CallToAction';
import URL from '@evercall/url/urlConstants';
import alignStyles from '@dealroadshow/uikit-styles/helpers/align.module.scss';
import landingStyles from '@framework/ui/Pages/Landing/Sections/base.module.scss';

const GetStarted = () => {
  return (
    <CallToAction
      dataTest="getStartedSection"
      title="Ready to get started?"
      description="Evercall is ready when you are. Schedule your operator assisted conference call now or contact us."
      actions={ (
        <div className={ alignStyles.alignCenter }>
          <Link to={ URL.SCHEDULE }>
            <Button
              variant={ ButtonVariantType.action }
              className={ landingStyles.actionButton }
              title="Schedule Your Event"
              dataTest="scheduleEventButton"
            />
          </Link>
        </div>
      ) }
    />
  );
};

export default GetStarted;
